// Helpers for metadata dropdown values that can contain literal `<` / `>`
// (e.g. "<RM20,000", ">RM10M"). These are trusted metadata codes, but the raw
// angle brackets get mangled by the API XSS filter, so we HTML-escape them
// before submitting and decode/sanitize when reading them back.

const escapeHtml = (value: string): string =>
	value
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");

const decodeHtml = (value: string): string =>
	value
		.replace(/&#39;/g, "'")
		.replace(/&quot;/g, '"')
		.replace(/&gt;/g, ">")
		.replace(/&lt;/g, "<")
		.replace(/&amp;/g, "&");

// Normalize then escape so the result is stable whether or not the input is
// already escaped. Use before submitting a value to the API.
export const escapeMetadataValue = <T extends string | number | null | undefined>(
	value: T,
): T => {
	if (value === null || value === undefined || value === "") return value;
	return escapeHtml(decodeHtml(String(value))) as T;
};

// Decode escaped entities back to the raw value so it matches dropdown option
// codes. Use when loading a saved value into a form for editing.
export const decodeMetadataValue = <T extends string | number | null | undefined>(
	value: T,
): T => {
	if (value === null || value === undefined || value === "") return value;
	return decodeHtml(String(value)) as T;
};
